import React from 'react'
import styled from '@emotion/styled'

const SelectControl = styled.select`
  border: none;
  border-radius: 0;
  background: transparent;
  font-weight: 600;
  color: #171717;
  cursor: pointer;
    
  &:focus {
    outline: none;
  }
`

const Select = ({
  options,
  value,
  setValue = () => null
}) => {
  const optionTags = options.map(option => <option key={option.value} value={option.value}>{option.title}</option>)

  return <SelectControl value={value} onChange={event => {
    setValue(event.target.value)}
  }>
    {optionTags}
  </SelectControl>
}

export default Select

